import { UpdateTemplateCategory, UpdateTemplateCategoryVariables } from './__generated__/UpdateTemplateCategory'

import { gql } from 'apollo-boost'
import { useMutation } from '@apollo/react-hooks'

const MUTATION = gql`
  mutation UpdateTemplateCategory($input: UpdateTemplateCategoryInputV2!) {
    updateTemplateCategory: updateTemplateCategoryV2(input: $input) {
      ... on TemplateCategoryV2 {
        id
        title
      }
      ... on TemplateCategoryErrorV2 {
        type
        error
      }
    }
  }
`

export const useUpdateTemplateCategory = () =>
  useMutation<UpdateTemplateCategory, UpdateTemplateCategoryVariables>(MUTATION)
